var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 168 168",
    style: {
      enableBackground: "new 0 0 168 168"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#C2EED9",
    className: "st0",
    cx: 84,
    cy: 84,
    r: 84
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40D9B5",
    opacity: 0.3,
    className: "st1",
    d: "M84,168c17.1,0,33-5.1,46.3-13.9C124.6,133.3,105.6,118,83,118c-22.2,0-40.9,14.7-46.9,35 C49.7,162.4,66.2,168,84,168z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#40D9B5",
    opacity: 0.3,
    className: "st1",
    cx: 84,
    cy: 84,
    r: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3762c308f651820056eb935a569cff7d.svg";
export { ForwardRef as ReactComponent };